<template>
  <el-cascader
    ref="cascader"
    style="width:100%;"
    v-model="selecteds"
    :clearable="clearable"
    :options="options"
    :props="vprops"
    :size="size"
    :disabled="disabled"
    @change="onChange"
    :placeholder="placeholder"
  ></el-cascader>
</template>
<script>
import { request } from '@/api/service'
import { mapState } from 'vuex'
export default {
  props: {
    placeholder: { type: String, default: () => '请选择' },
    props: { type: Object, default: () => {} },
    value: Array,
    lastValue: String,
    valueString: String,
    pathLabels: String,
    pathValue: [String, Array],
    disabled: Boolean,
    size: { type: String, default: 'small' },
    clearable: { type: Boolean, default: true },
    dataScope: { type: Boolean, default: true },
  },
  data() {
    return {
      options: [],
      selecteds: this.value,
      vprops: {
        checkStrictly: true,
        lazyLoad: (node, resolve) => this.lazyLoadData(node, resolve),
        ...this.props,
      },
    }
  },
  watch: {
    lastValue: {
      handler(val) {
        if (!this.value) {
          if (!val) return (this.selecteds = [])
          const { valuePath = null } = this.optionsMap[this.lastValue] || {}
          this.selecteds = JSON.parse(valuePath) || []
        }
      },
    },
  },
  computed: {
    ...mapState('admin/system', ['app']),
    optionsMap() {
      const options = this.options || []
      return this.toMap(options)
    },
  },
  async created() {
    const nodes = await this.getData()
    this.options = nodes

    if (this.lastValue) {
      const { valuePath = null } = this.optionsMap[this.lastValue] || {}
      this.selecteds = JSON.parse(valuePath) || []
    }
  },
  methods: {
    toMap(options) {
      return options.reduce((r, n) => {
        r[n.value] = n
        if (n.children && n.children.length) {
          r = { ...r, ...this.toMap(n.children) }
        }
        return r
      }, {})
    },
    onChange(vals) {
      this.$emit('update:value', vals)
      this.$emit('update:valueString', JSON.stringify(vals))
      if (this.vprops.multiple) {
        // 多选
        this.handlerMultipleChange()
      } else {
        // 单选
        this.handlerSingleChange()
      }
    },
    handlerSingleChange() {
      const checkedNodes = this.$refs.cascader.getCheckedNodes()
      if (!checkedNodes || !checkedNodes.length) {
        this.clearValue()
      }
      const checkedNode = checkedNodes[0] || {}
      let pathLabels = checkedNode.pathLabels || []
      this.$emit('update:lastValue', checkedNode.value)
      this.$emit('update:pathLabels', pathLabels.join('/'))
      this.$emit('update:level', checkedNode.level)
    },
    handlerMultipleChange() {
      // TODO
    },
    clearValue() {
      this.$emit('update:lastValue', '')
      this.$emit('update:pathLabels', '')
      this.$emit('update:level', 0)
    },
    getCheckedNodes() {
      return this.$refs.cascader.getCheckedNodes()
    },
    async lazyLoadData(node, resolve) {
      const { level, value } = node
      const nodes = await this.getData({ level, depCode: value })
      resolve(nodes)
    },
    getData(params) {
      return this.getApi(params).then((res) => {
        var data = res.body.data
        data.forEach((v) => {
          v.disabled = true
        })
        return data
      })
    },
    getApi(params) {
      return request({
        url: '/sys/common/dict/dep/level/select',
        method: 'post',
        params,
      })
    },
  },
}
</script>
